/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/popover/popover';
const styles_NgbPopoverWindow:any[] = ([] as any[]);
export const RenderType_NgbPopoverWindow:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbPopoverWindow,data:{}});
export function View_NgbPopoverWindow_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),1,'h3',[['class','popover-title']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['',
      ''])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','popover-content']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted((null as any),['\n    ']))],(null as any),(_ck,_v) => {
    var _co:i1.NgbPopoverWindow = _v.component;
    const currVal_0:any = _co.title;
    _ck(_v,2,0,currVal_0);
  });
}
export function View_NgbPopoverWindow_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-popover-window',
      [['role','tooltip']],[[8,'className',0],[8,'id',0]],(null as any),(null as any),
      View_NgbPopoverWindow_0,RenderType_NgbPopoverWindow)),i0.ɵdid(49152,(null as any),
      0,i1.NgbPopoverWindow,([] as any[]),(null as any),(null as any))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = ('popover show popover-' + i0.ɵnov(_v,1).placement);
        const currVal_1:any = i0.ɵnov(_v,1).id;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export const NgbPopoverWindowNgFactory:i0.ComponentFactory<i1.NgbPopoverWindow> = i0.ɵccf('ngb-popover-window',
    i1.NgbPopoverWindow,View_NgbPopoverWindow_Host_0,{placement:'placement',title:'title',
        id:'id'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvcG9wb3Zlci9wb3BvdmVyLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvcG9wb3Zlci9wb3BvdmVyLmQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL3BvcG92ZXIvcG9wb3Zlci5kLnRzLk5nYlBvcG92ZXJXaW5kb3cuaHRtbCIsIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvcG9wb3Zlci9wb3BvdmVyLmQudHMuTmdiUG9wb3ZlcldpbmRvd19Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxoMyBjbGFzcz1cInBvcG92ZXItdGl0bGVcIj57e3RpdGxlfX08L2gzPjxkaXYgY2xhc3M9XCJwb3BvdmVyLWNvbnRlbnRcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICAgIiwiPG5nYi1wb3BvdmVyLXdpbmRvdz48L25nYi1wb3BvdmVyLXdpbmRvdz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7OztvQkNBQSwyQ0FDSTtNQUFBO01BQUEsNENBQTBCO01BQUEsTUFBYztNQUFBLCtFQUE2QjtNQUFBLEdBQStCOztJQUExRTtJQUFBOzs7O29CQ0Q5QjtNQUFBO3lEQUFBLFVBQUE7TUFBQTs7UUFBQTtRQUFBO1FBQUEsV0FBQSxtQkFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/popover/popover.ngfactory.ts